export default __webpack_public_path__ + "static/media/CodeGraph.08bc73c6.svg";